import translate from "./translate.es6"

var translationFunction = translate
var getItemsPerPage = () => {
  return 50
}

export default {
  translationFunction,
  getItemsPerPage,
}
